var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
// Internal dependencies
import { UserContext } from '../../auth';
import { DeleteButtonSG } from './DeleteButtonSG';
import { ConfirmDialogSG } from './ConfirmDialogSG';
import { LOG_LEVELS, SERVICES, ENDPOINTS } from '../../constants';
import { axiosClient } from '../../axios';
/**
 * Delete confirmation button
 * @param props DeleteConfirmButtonSG Props
 * @returns JSX Element
 */
export function DeleteConfirmButtonSG(props) {
    const { /** Translation function */ t } = useTranslation();
    const /** User credential */ user = useContext(UserContext);
    const { handleDeleteConfirmClick, disabled, cleanOthers, } = props;
    const [
    /** Delete confirmation dialog status */ deleteDialogOpen, 
    /** deleteDialogOpen setter */ setDeleteDialogOpen,] = useState(false);
    /** Open Delete confirm dialog */
    const handleDeleteClickOpen = () => {
        setDeleteDialogOpen(true);
        return true;
    };
    /** Close delete confirm dialog */
    const handleDeleteClickClose = () => {
        setDeleteDialogOpen(false);
        if (cleanOthers) {
            // If need to handle after cancel
            cleanOthers();
        }
        return true;
    };
    /**
     * Close Dialog after delete
     * @returns Promise of sucess/fail
     */
    const closeDialogAfterDelete = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            // Handle delete confirm click
            yield handleDeleteConfirmClick();
            // Close the deletion confirm dialog
            handleDeleteClickClose();
            return true;
        }
        catch (err) {
            // Close the deletion confirm dialog
            handleDeleteClickClose();
            // Log error
            axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                level: LOG_LEVELS.ERROR,
                logMessage: `DeleteConfirmButton, closeDialogAfterDelete, ${err === null || err === void 0 ? void 0 : err.message}`,
                metadata: {
                    env: process.env.ENV,
                    service: SERVICES.DOCUMENTS,
                    userId: user === null || user === void 0 ? void 0 : user.uid,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                },
            });
            if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) {
                // If the error is from server
                // Notify user with the server error message
                toast.error((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message);
                return false;
            }
            ;
            // Notify user with simple message
            toast.error(t('Something went wrong. We are figuring it out.'));
            return false;
        }
        ;
    });
    return (_jsxs(_Fragment, { children: [_jsx(DeleteButtonSG, { disabled: disabled, handleDeleteClickOpen: handleDeleteClickOpen }), _jsx(ConfirmDialogSG, { deleteDialogOpen: deleteDialogOpen, handleDeleteClickClose: handleDeleteClickClose, handleDeleteConfirmClick: closeDialogAfterDelete })] }));
}
;
